// extracted by mini-css-extract-plugin
export var shake = "_1e-0";